var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { repairService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
var FamilyPlanningDataService = /** @class */ (function () {
    function FamilyPlanningDataService() {
    }
    /**
     * 计生资料查询
     */
    FamilyPlanningDataService.prototype.search = function (data, page, sort, loading) {
        return this.netService.send({
            server: repairService.familyPlanningDataController.search,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 计生资料创建
     */
    FamilyPlanningDataService.prototype.insert = function (data, loading) {
        return this.netService.send({
            server: repairService.familyPlanningDataController.insert,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除计生资料
     */
    FamilyPlanningDataService.prototype.delete = function (data, loading) {
        return this.netService.send({
            server: repairService.familyPlanningDataController.delete,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改计生资料
     */
    FamilyPlanningDataService.prototype.update = function (data, loading) {
        return this.netService.send({
            server: repairService.familyPlanningDataController.update,
            data: data,
            loading: loading
        });
    };
    /**
     * 修改计生凭证
     */
    FamilyPlanningDataService.prototype.addCredential = function (credentialSet, id, loading) {
        return this.netService.send({
            server: repairService.familyPlanningDataController.addCredential,
            data: {
                credentialSet: credentialSet,
                id: id
            },
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], FamilyPlanningDataService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], FamilyPlanningDataService.prototype, "search", null);
    return FamilyPlanningDataService;
}());
export { FamilyPlanningDataService };
